import {JwtAxios} from "@/packaging";

export const faqAPI = {
    async GetFaqList(page){
        const responseModel = await JwtAxios.get(`/Faq/GetFaqList?siteType=1&page=${page}`);
        return responseModel
    },
}